import {createApp} from 'vue'
import App from './App.vue'
import axios from 'axios'
import router from './router'

// Optional, since every component import their Bootstrap functionality
// the following line is not necessary
// import 'bootstrap'
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.min.js";

let baseUrlBackend;
if (process.env.NODE_ENV === 'production') {
    baseUrlBackend = 'http://pixsmart.ru/backend';
} else {
    baseUrlBackend = 'http://localhost:5000';
}

const instance = axios.create({
    baseURL: baseUrlBackend,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': '*',
    },
});

const app = createApp(App);
app.config.globalProperties.$axios = instance;
app.config.globalProperties.$fileDownload = require('js-file-download');
app.use(router).mount('#app');